import axios from "axios";

// /**
//  * Initialize Company/Jobs Page View counter
//  * Tracks page views for company and job post types
//  */

class Views {
  // Initiate object
  constructor() {
    this.postId = gbThemeData.post_id;
    this.postType = gbThemeData.post_type;

    if (this.postId && (this.postType === "company" || this.postType === "jobs")) {
      this.trackPageView();
    }
  }

  // Methods
  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }

  getViewedPages() {
    const cookie = this.getCookie("sdhk_page_views");
    if (!cookie) return {};

    try {
      return JSON.parse(decodeURIComponent(cookie));
    } catch (e) {
      console.error("Error parsing page views cookie:", e);
      return {};
    }
  }

  setViewedPages(viewedPages) {
    const cookieValue = encodeURIComponent(JSON.stringify(viewedPages));
    this.setCookie("sdhk_page_views", cookieValue, 30); // Cookie expires in 30 days
  }

  hasViewedRecently(postId) {
    const viewedPages = this.getViewedPages();
    const lastViewed = viewedPages[postId];

    if (!lastViewed) return false;

    const now = Date.now();
    const timeDiff = now - lastViewed;
    const hoursDiff = timeDiff / (1000 * 60 * 60);

    return hoursDiff < 24;
  }

  markAsViewed(postId) {
    const viewedPages = this.getViewedPages();
    viewedPages[postId] = Date.now();

    // Clean up old entries (older than 24 hours) to keep cookie size manageable
    const now = Date.now();
    Object.keys(viewedPages).forEach((id) => {
      const timeDiff = now - viewedPages[id];
      const hoursDiff = timeDiff / (1000 * 60 * 60);
      if (hoursDiff >= 24) {
        delete viewedPages[id];
      }
    });

    this.setViewedPages(viewedPages);
  }

  async trackPageView() {
    if (this.hasViewedRecently(this.postId)) {
      return;
    }

    // If noo recent view, track view
    const data = {
      postId: this.postId,
    };

    try {
      const response = await axios.post(
        gbThemeData.root_url + "/wp-json/all/v1/manageViews",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-WP-Nonce": gbThemeData.nonce,
          },
        }
      );
      this.markAsViewed(this.postId);
    } catch (error) {
      console.error("Error during page view tracking:", error);
      if (error.response) {
        console.error("Error response:", error.response.data);
      }
    }
  }
}

export default Views;
